/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Demand_SubmitInputs */

const cs_public_site_demand_submit = /** @type {(inputs: Public_Site_Demand_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odeslat poptávku`)
};

const en_public_site_demand_submit = /** @type {(inputs: Public_Site_Demand_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit demand`)
};

/**
* | output |
* | --- |
* | "Submit demand" |
*
* @param {Public_Site_Demand_SubmitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_demand_submit = /** @type {((inputs?: Public_Site_Demand_SubmitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Demand_SubmitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_demand_submit(inputs)
	return cs_public_site_demand_submit(inputs)
});